import { useState, type JSX } from 'react';

import { Button } from '@/components/ui/button.js';
import { Input } from '@/components/ui/input.js';

/**
 * The keyboard half of a web takeover.
 *
 * A pointer alone cannot clear a stuck form: the human clicks the field on the live view, then types
 * here, and the text rides the same command queue as a tap. Never a password — a takeover is for a
 * control the agent cannot drive, and a credential belongs in the value request beside it, where it is
 * masked and never echoed.
 */
export function TakeoverTypingRow({
  disabled,
  onType,
}: {
  disabled: boolean;
  onType: (text: string) => void;
}): JSX.Element {
  const [text, setText] = useState('');

  const send = () => {
    const trimmed = text.trim();
    if (disabled || !trimmed) return;
    onType(trimmed);
    setText('');
  };

  return (
    <div className="flex gap-2">
      <Input
        data-testid="takeover-type-input"
        value={text}
        placeholder="Type into the focused field"
        aria-label="Text to type into the page"
        disabled={disabled}
        onChange={(event) => setText(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') send();
        }}
      />
      <Button
        type="button"
        variant="outline"
        data-testid="takeover-type-send"
        disabled={disabled}
        onClick={send}
      >
        Type
      </Button>
    </div>
  );
}
